// extracted by mini-css-extract-plugin
export default {"autocomplete":"vQFhWgpx7BmrH7RZXh5g","tags":"Jto5LWpjDI2p3Oe55_yA"};